<div class="shop-layout__sidebar">
    <div class="block block-sidebar" [ngClass]="{
        'block-sidebar--offcanvas--always': offcanvas === 'always',
        'block-sidebar--offcanvas--mobile': offcanvas === 'mobile',
        'block-sidebar--open': isOpen
    }">


        <div class="block-sidebar__backdrop" (click)="sidebar.close()"></div>
        <div class="block-sidebar__body">
            <div class="block-sidebar__header">
                <div class="filter-header">
                    {{"filters"|translate}}
                </div>
                <button class="block-sidebar__close" type="button" (click)="sidebar.close()">
                    <app-icon name="cross-20" size="20"></app-icon>
                </button>
            </div>
            <div class="block-sidebar__item">
                <form [formGroup]="form" class="widget widget-filters bg-card-new card-radius-06 border-0" [ngClass]="{
                    'widget-filters--offcanvas--always': offcanvas === 'always',
                    'widget-filters--offcanvas--mobile': offcanvas === 'mobile'
                }">
                    <div class="filter-header">
                        {{"filters"|translate}}
                    </div>
                    <ng-container *ngIf="categoryData">
                        <h4 class="widget-filters__title filter__title"><span class="me-2">•</span>
                            {{"categories"|translate}}</h4>
                        <div class="widget-filters__list mx-4" *ngIf="categoryData && isSubcategories">
                            <div class="widget-filters__item">
                                <div class="filter filter--opened" appCollapseItem="filter--opened">
                                    <div class="filter__body" appCollapseContent>
                                        <div class="filter__container">
                                            <ul class="filter-categories__list">
                                                <ng-container *ngIf="!isCompany&&!isSearch">
                                                    <li *ngFor="let subcategory of categoryData" class="list-item">
                                                        <a [routerLink]="(['/','category',  subcategory?.seo?.slug])">
                                                            {{ translateHelper.localize(subcategory.name) }}
                                                        </a>
                                                    </li>
                                                </ng-container>
                                                <ng-container *ngIf="isCompany||isSearch">
                                                    <li *ngFor="let subcategory of categoryData" class="list-item">
                                                        <a class="cursor-pointer"
                                                            (click)="updateUrl({category: subcategory?.seo?.slug},['./'])">
                                                            {{ translateHelper.localize(subcategory?.name) }}
                                                        </a>
                                                    </li>
                                                </ng-container>
                                            </ul>
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </div>
                        <div class="widget-filters__list mx-4" *ngIf="categoryData && !isSubcategories">
                            <div class="widget-filters__item">
                                <div class="filter filter--opened" appCollapseItem="filter--opened">
                                    <div class="filter__body" appCollapseContent>
                                        <div class="filter__container">
                                            <ul class="filter-categories__list">
                                                <ng-container *ngIf="!isCompany&&!isSearch">
                                                    <li *ngFor="let pathCategory of categoryData.path"
                                                        class="list-item">
                                                        <a [routerLink]="(['/','category', pathCategory.seo?.slug])">
                                                            <app-icon class="filter-categories__arrow"
                                                                name="arrow-rounded-left-6x9" size="6x9">
                                                            </app-icon> {{ translateHelper.localize(pathCategory?.name)
                                                            }}
                                                        </a>
                                                    </li>
                                                </ng-container>
                                                <ng-container *ngIf="isCompany||isSearch">
                                                    <li class="list-item">
                                                        <a class="cursor-pointer" (click)="updateUrl({},['./'])">
                                                            <app-icon class="filter-categories__arrow"
                                                                name="arrow-rounded-left-6x9" size="6x9">
                                                            </app-icon> <!-- <span class="me-2">•</span> -->
                                                            {{"all_categories"|translate}}
                                                        </a>
                                                    </li>
                                                    <li *ngFor="let pathCategory of categoryData.path"
                                                        class="list-item">
                                                        <a class="cursor-pointer"
                                                            (click)="updateUrl({category: pathCategory?.seo?.slug},['./'])">
                                                            <app-icon class="filter-categories__arrow"
                                                                name="arrow-rounded-left-6x9" size="6x9">
                                                            </app-icon> {{ translateHelper.localize(pathCategory?.name)
                                                            }}
                                                        </a>
                                                    </li>
                                                </ng-container>
                                                <li class="list-item active">
                                                    <a *ngIf="!isCompany&&!isSearch"
                                                        [routerLink]="(['/','category', categoryData?.seo?.slug])">
                                                        {{ translateHelper.localize(categoryData?.name) }}
                                                    </a>
                                                    <a class="cursor-pointer" *ngIf="isCompany||isSearch"
                                                        (click)="updateUrl({category: categoryData?.seo?.slug},['./'])">
                                                        {{ translateHelper.localize(categoryData?.name) }}
                                                    </a>
                                                </li>
                                                <li *ngFor="let subcategory of categoryData.subCategories ? categoryData.subCategories : categoryData.siblings"
                                                    class="list-item item-child">
                                                    <a *ngIf="!isCompany&&!isSearch"
                                                        [routerLink]="(['/','category', subcategory?.seo?.slug])">{{
                                                        translateHelper.localize(subcategory.name) }}</a>
                                                    <a class="cursor-pointer" *ngIf="isCompany||isSearch"
                                                        (click)="updateUrl({category: subcategory?.seo?.slug},['./'])">{{
                                                        translateHelper.localize(subcategory.name) }}</a>
                                                </li>
                                            </ul>
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </ng-container>
                    <ng-container *ngFor="let filter of filtersData">

                        <div class="col-span-12">
                            <ng-container
                                *ngIf="filter.type =='list' || filter.type =='brand' || filter.type =='company'">
                                <app-select-input *ngIf="!filter.filterType || filter.filterType == 'list'"
                                    (selectChange)="applyFilters()" [multiple]="filter.multipleSelect || false"
                                    [control]="form.get(filter.name.en)" [label]="translateHelper.localize(filter.name)"
                                    [customLabel]="translateHelper.localize(filter.filterLabel)"
                                    [selectList]="filter.value" appearance="filter" floatLabel="always"
                                    [placeholder]="('please_select'|translate) + ' ' + translateHelper.localize(filter.name)"></app-select-input>

                                <app-select-search *ngIf="filter.filterType == 'search'" (selectChange)="applyFilters()"
                                    [multiple]="filter.multipleSelect || false" [control]="form.get(filter.name.en)"
                                    [label]="translateHelper.localize(filter.name)"
                                    [customLabel]="translateHelper.localize(filter.filterLabel)"
                                    [selectList]="filter.value" appearance="filter" floatLabel="always"
                                    [placeholder]="('please_select'|translate) + ' ' + translateHelper.localize(filter.name)"></app-select-search>


                                <app-select-button *ngIf="filter.filterType == 'buttons'"
                                    (selectChange)="applyFilters()" [multiple]="filter.multipleSelect || false"
                                    [control]="form.get(filter.name.en)" [label]="translateHelper.localize(filter.name)"
                                    [customLabel]="translateHelper.localize(filter.filterLabel)"
                                    [selectList]="filter.value" floatLabel="always" appearance="filter"
                                    [placeholder]="('please_select'|translate) + ' ' + translateHelper.localize(filter.name)"></app-select-button>
                            </ng-container>
                            <ng-container *ngIf="filter.type =='checkbox'">
                                <app-checkbox-input [control]="form.get(filter.name.en)"
                                    [label]="translateHelper.localize(filter.name)">
                                </app-checkbox-input>
                            </ng-container>
                            <ng-container *ngIf="filter.type =='exact'">
                                <app-text-input [control]="form.get(filter.name.en)" appearance="legacy"
                                    [label]="translateHelper.localize(filter.name)"></app-text-input>
                            </ng-container>
                            <!-- <ng-container *ngIf="filter?.type =='price'">
                                <div class="filter-price">
                                    <div class="filter-price__slider mx-4">
                                        <div class="ngx-slider-custom">
                                            <ngx-slider [formControl]="form.get(filter.name.en)" [options]="{
                                                        animate: false,
                                                        mouseEventsInterval: 10,
                                                        rightToLeft: rightToLeft,
                                                        floor: filter.value[0],
                                                        ceil: filter.value[1],
                                                        step: filter.step || 1
                                                    }" (userChangeEnd)="applyFilters()"
                                                #slider></ngx-slider>
                                        </div>
                                    </div>
                                    <div class="filter-price__title mx-4">
                                        <span class="filter-price__min-value">{{ (rightToLeft ? slider.highValue
                                            : slider.value)|currencyFormat }}</span>
                                        –
                                        <span class="filter-price__max-value">{{ (rightToLeft ? slider.value :
                                            slider.highValue)|currencyFormat }}</span>
                                    </div>
                                </div>
                            </ng-container> -->
                            <!--  <ng-container *ngIf="filter.type =='range' ">
                                <app-range-input [minControl]="form.get(filter.name.en).controls['min']"
                                    [maxControl]="form.get(filter.name.en).controls['max']" appearance="filter"
                                    [label]="filter.name" [customLabel]="filter.filterLabel"></app-range-input>
                            </ng-container> -->
                        </div>
                    </ng-container>
                    <div class="filter-actions">
                        <button (click)="reset()" class="btn btn-sm bg-gray-light">
                            <div class="label font-bold">{{"reset"|translate}}</div>
                        </button>

                        <!-- <button (click)="applyFilters()" class="btn btn-sm apply-btn">
                            <div class="label">{{"apply"|translate}} ></div>
                        </button> -->
                    </div>

                </form>
            </div>
        </div>
    </div>
</div>